<template>
    <div>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" v-loading="loading" element-loading-text="加载中"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-form-item label="请选择月份：" prop="classesDate">
                <el-date-picker v-model="ruleForm.classesDate" type="month" value-format="yyyy-MM" placeholder="选择日期"
                    format="yyyy-MM">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit('ruleForm')">确定</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
export default {
    data() {
        return {
            ruleForm: {
                classesDate: ""
            },
            rules: {
                classesDate: [
                    { required: true, message: '请选择月份', trigger: 'blur' },
                ],
            },
            loading: false
        }
    },
    props: ["closeModal"],
    created() {

    },
    methods: {
        onSubmit(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true
                    $utils.api.load(`/admin/system/date`, this.ruleForm, 'POST').then(res => {
                        console.log(res);
                        if (res.code == 200) {
                            this.$emit("closeModal", true)

                        }
                        this.loading = false
                    })
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style></style>